<template>

  <div class="single-element">

    <section>
      <label>ID</label>
      <span class="bold">{{sync.id}}</span>
    </section>

    <section>
      <label>Rchiesto da</label>
      <span class="bold">{{getUserSync}}</span>
    </section>

    <section class="datetime">
      <label><span>Inizio - Fine</span> <span><img class="icon" :src="iconTimeStart" alt=""></span></label>
      <span class="date">{{sync.created_at}}</span><br>
      <span class="date" v-show="isConcluded">{{sync.updated_at}}</span>
    </section>

    <section class="status single-sync">
      <label>Stato</label>
      <span class="bold" :data-status="getStatus">{{getStatus}}</span>
    </section>

    <section class="status general-sync-rows">
      <label>Stato righe</label>
      <span v-if="hasFailures" class="bold failed">fallito</span>
      <span v-else class="bold successeful">successo</span>
    </section>

    <section class="manage-rows">
      <button class="belt-btn-small" @click="manage_sync_rows = true">gestisci righe</button>
    </section>

    <sync-rows v-if="manage_sync_rows" :sync="sync"/>

  </div>

</template>

<script>
import SyncRows from './sync-rows.vue'
export default{

  components: {SyncRows},
  props: {
    sync: {type: Object}
  },

  data: function(){

    return {
      manage_sync_rows: false,
    }

  },

  mounted: function() {

  },

  computed: {



    getUserSync: function() {
      return this.sync.user_id === 0 ? 'B2B' : this.sync.user_id + ' - ' + this.sync.username;
    },

    getStatus: function() {
      switch(this.sync.status) {
        case null:
        return 'in corso';
        break;

        case 0:
        return 'interrotto'
        break;

        case 1:
        return 'concluso'
        break;
      }
    },

    isConcluded: function() {
      return this.sync.status !== null;
    },

    hasFailures: function() {
      for(let i in this.sync.rows) {
        if (this.sync.rows[i].status === 0)
            return true;
      }
      return false;
    },

    iconTimeStart: function() {
      let hour = new Date(this.sync.created_at).getHours();
      return hour > 6 && hour < 18 ? this.url('/media/icons/svg/sun.svg') : this.url('/media/icons/svg/night.svg');
    }



  },

  methods: {

  }

}
</script>

<style scoped>
div.single-element{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
div.single-element section{
  width: auto;
  height: auto;
}
div.single-element section label{
  display: block;
  width: 100%;
}
div.single-element section.datetime label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
div.single-element section.datetime label img.icon{
  width: 20px;
}

div.single-element section.manage-rows{
  text-align: right;
}

div.single-element section span.date {
  font-size: 0.8em;
}
div.single-element section.status span.failed{
  color: var(--red);
}
div.single-element section.status span.successeful{
  color: var(--blue);
}

div.single-element section.status.single-sync span[data-status="in corso"] {
  color: var(--black);
}
div.single-element section.status.single-sync span[data-status="concluso"] {
  color: var(--blue);
}
div.single-element section.status.single-sync span[data-status="interrotto"] {
  color: var(--red);
}
</style>
